@if (icon()) {
  <mat-icon svgIcon="box" />
}
<ng-content> </ng-content>
